function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from 'react';
import { WidgetTitle, WidgetDescription, WidgetSpinner } from '../';
import "./WidgetLoading.scss";

class WidgetLoading extends Component {
  render() {
    const _this$props = this.props,
          title = _this$props.title,
          description = _this$props.description;

    if (title && description) {
      return React.createElement("div", {
        className: "admin-widget__loading"
      }, React.createElement(WidgetSpinner, this.props), React.createElement("p", null, title));
    } else {
      return React.createElement("div", {
        className: "admin-widget__loading"
      }, React.createElement(WidgetSpinner, this.props), React.createElement("p", null, title));
    }
  }

}

_defineProperty(WidgetLoading, "defaultProps", {
  title: undefined,
  description: undefined
});

export default WidgetLoading;